import React from "react";
import CategoryCard from "./common/CategoryCard";
import { useTranslation } from "react-i18next";
import Reveal from "motion/Reveal";
import { useParams } from "react-router-dom";

const CategoryTitle = ({ sub, data, title }) => {
  const [t, i18] = useTranslation("global");
  const { name } = useParams();

  return (
    <div className="container-xxl py-6 border-b">
      <h1 className="text-[22px] lg:text-[32px] font-bold ">{title}</h1>
      {!sub && (
        <>
          <div className="flex flex-wrap gap-3 my-3 justify-around lg:justify-start">
            {data?.map((item) => (
              <Reveal>
                <CategoryCard
                  t={t}
                  i18={i18}
                  data={item}
                  prev={name}
                />
              </Reveal>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default CategoryTitle;
